import type { BoxProps } from "@mui/material";
import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";
import useToggleState from "../hooks/useToggleState";
import useVerticalOverflowDetection from "../hooks/useVerticalOverflowDetection";
import ShowMoreLessButton from "./ShowMoreLessButton";

interface Props {
  maxHeight: number;
  containerProps?: BoxProps;
  expandButtonText?: string;
  collapseButtonText?: string;
}

const ExpandableBox = ({
  maxHeight,
  containerProps,
  expandButtonText,
  collapseButtonText,
  children,
}: PropsWithChildren<Props>) => {
  const [expanded, toggleExpanded] = useToggleState(false);
  const { hasOverflow, containerRef } = useVerticalOverflowDetection([maxHeight, children], { disabled: expanded });

  const { sx, ...props } = containerProps ?? {};

  return (
    <>
      <Box
        {...props}
        ref={containerRef}
        sx={
          expanded
            ? { ...sx }
            : {
                maxHeight,
                overflow: "hidden",
                maskImage: hasOverflow ? "linear-gradient(0deg, transparent, black 35%)" : "none",
                ...sx,
              }
        }
      >
        {children}
      </Box>

      {(hasOverflow || expanded) && (
        <ShowMoreLessButton
          expanded={expanded}
          onClick={toggleExpanded}
          expandButtonText={expandButtonText}
          collapseButtonText={collapseButtonText}
        />
      )}
    </>
  );
};

export default ExpandableBox;
